import axios from 'axios';
import API, { NEW_API } from '../../Api';
import {
  DistanceRequest,
  EditOrderRequestCart,
  ItemTotalsPayloadInteface,
  UpdateOrderTip,
} from './orderModels';
import { GetOrderDetails } from '../cart/cartModels';
import { encryptJson, handleEncrypt, decryptOrderIdIfEncrypted } from '../../utils/react-ec-utils';
import { getCookie } from '../../../helper/cookieHelper';
import { USER_DETAILS, USER_ID } from '../../constants';
import { createRequest } from '../../utils/hmac-utils';

// Get a Order Detail
// export function getOrderDetails(orderData: GetOrderDetails) {
//   const enOrderId = handleEncrypt(orderData?.orderId);

//   return API({
//     method: "get",
//     url: "/api/customers/order/customer",
//     params: orderData.sortOrder
//       ? { data: enOrderId, sortOrder: orderData.sortOrder }
//       : {
//         data: enOrderId,
//         },
//   });
// }
export function getNewOrderDetails(orderData: GetOrderDetails) {
  if (!orderData?.orderId) {
    throw new Error('Order ID is required');
  }

  const payload = {
    orderId: orderData.orderId,
    splitId: orderData?.splitId,
    sortOrder: orderData?.sortOrder,
    transactionId: orderData?.transactionId,
  };

  const enOrderId = encryptJson(payload);
  return NEW_API({
    method: 'post',
    url: '/orders/customer',
    data: { data: enOrderId },
  });
}


const getUserDetailsFromCookie = () => getCookie(USER_DETAILS) || {};

export async function getOrderDetails(orderData: GetOrderDetails) {
  // Validate required fields
  if (!orderData?.orderId) {
    throw new Error('Order ID is required');
  }

  const payload = {
    orderId: orderData.orderId,
    splitId: orderData?.splitId,
    sortOrder: orderData?.sortOrder,
    transactionId: orderData?.transactionId,
  };

   const enOrderId = encryptJson(payload);
    // const hmacRequest = await createRequest(payload);
  return API({
    method: 'post',
    url: '/api/customers/order/customer',
    data: { data: enOrderId },
        // data : hmacRequest
  });
}

// Get Customer Orders
export function getOrders(customerId: string) {
  const userDetails = getUserDetailsFromCookie();

  return API({
    method: 'get',
    url: `/order/getOrders?emailId=${encodeURIComponent(userDetails?.email || "")}&mobileNo=${encodeURIComponent(userDetails?.mobilePhone || "")}`,
    params: {
      search: `customerId:${customerId}`,
      sort: 'orderDate,desc',
    },
  });
}

// Get past experience customer orders
export function getLatestOrders(customerId: string) {
  return API({
    method: 'get',
    url: '/order/customer/getOrders?sort=orderDate,desc',
    params: {
      search: `customerId:${customerId}`,
      page: '0',
      size: '1000',
      sort: 'orderTime,desc',
    },
  });
}

// For Floating Bar
export function getActiveOrders(customerId: string) {
  let data = encryptJson({
    search: `customerId:${customerId}`,
    page: 0,
    size: 1000,
    sort: 'orderTime,desc',
  });
  return API({
    method: 'post',
    url: '/api/customers/order/filter',
    data: { data: data },
  });
}

// Calculate Distance
export async function getDistanceBtwResUser(details: DistanceRequest) {
  // const detailsData = encryptJson(details);
    const hmacRequest = await createRequest(details);
  return API({
    method: 'post',
    url: '/api/customers/order/getDistance',
    // data: { data: detailsData },
         data : hmacRequest
  });
}

export async function updateOrderAPI(cartData: EditOrderRequestCart) {
  const userID = getCookie(USER_ID);
  const resolvedCustomerId = userID || cartData?.customerId || '';
  const payload = {
    ...cartData,
    customerId:
      cartData?.tableId && resolvedCustomerId
        ? handleEncrypt(resolvedCustomerId)
        : resolvedCustomerId,
  };
  const data = encryptJson(payload);
  // const hmacRequest = await createRequest(payload);
  return API({
    method: 'put',
    url: '/api/customers/order/update',
    data: { data: data },
    // data : hmacRequest
    // headers: getAuthHeader(),
  });
}

export async function updateOrderTipAPI(cartData: UpdateOrderTip) {
  const userDetails = getUserDetailsFromCookie();
  const data = {
    orderId: cartData.orderId,
    tip: cartData.tipAmount,
    tipType: cartData.tipType ? cartData.tipType : 'FLATFEE',
    emailId: cartData.emailId ?? userDetails?.email ?? "",
    mobileNo: cartData.mobileNo ?? userDetails?.mobilePhone ?? "",
  };
  const payload = encryptJson(data);
  // const hmacRequest = await createRequest(data);
  return API({
    method: 'put',
     url: `/api/customers/order/add-tip/v2`,
    // url: `/api/customers/order/add-tip`,
    data: { data: payload },
    // data : hmacRequest
    //url: `/order/${cartData.orderId}/totals/tip?tip=${cartData.tipAmount}&tipType=${cartData.tipType?cartData.tipType :"FLATFEE"}&transactionId=${cartData.transactionId}`,
  });
}

export async  function getKDSOrderDetailAPI(orderId: any) {
  const data = {
    orderId: decryptOrderIdIfEncrypted(orderId?.orderId),
    splitId: orderId?.splitId ?? '',
    sortOrder: orderId?.sortOrder ?? 0,
    transactionId: orderId?.transactionId,
  };
  const payload = encryptJson(data)
  //  const hmacRequest = await createRequest(data);
  return API({
    method: 'post',
    url: '/api/customers/order/getKOTItemsBySortOrder',
    data: { data: payload },
        // data : hmacRequest
  });
}

export async function getNewKDSOrderDetailAPI(orderId: any) {
  return getKDSOrderDetailAPI(orderId);
}

export function getFilteredOrders(phone: string) {
  let data = encryptJson({ search: `phone:${phone}`, page: 0, size: 1000, sort: 'orderTime,desc' });
  return API({
    method: 'post',
    url: '/api/customers/order/filter',
    data: { data: data },
  });
}

export function manageItemTotalsApi(payload: ItemTotalsPayloadInteface) {
  const data = encryptJson(payload);
  return API({
    method: 'post',
    url: '/api/customers/order/totals',
    data: { data: data },
  });
}

export function customerOrders(payload: any) {
  const userDetails = getUserDetailsFromCookie();
  // const data = encryptJson(payload);
  return API({
    method: 'get',
    url: `/api/customers/orders?customerId=${payload.CustomerId}&locationId=${payload.locationId}&emailId=${encodeURIComponent(userDetails?.email || "")}&mobileNo=${encodeURIComponent(userDetails?.mobilePhone || "")}`,
    // data: { "data": data},
  });
}
export function currentOrder(payload: any) {
  // const data = encryptJson(payload);
  return API({
    method: 'get',
    url: `/api/customers/order/getOrder?orderId=${payload}`,
    // data: { "data": data},
  });
}
// curl --location 'http://localhost:9081/magilhub-data-services/api/customers/orders?customerId=10873b07-5baa-4b2f-bbc8-da2c07df8c8c&locationId=d15139f6-ea2b-4b4c-8541-7a9112bfd8bf'

